import { buildFirstThresholdMeasureAccessor } from '../../features/threshold';
import { formatValueAsMetricNumber } from '../numberFormatter';
import { Messages } from '../../localization';
import { DataRow, EffectiveDefinition } from '../../models';
import { RowSubtitleFunction } from './RowSubtitleFunction';

export const targetRowSubtitle = (definition: EffectiveDefinition): RowSubtitleFunction => {
  return (currentPoint: DataRow) => {
    const comparisonMeasureAccessor = buildFirstThresholdMeasureAccessor(definition);
    const targetValue = comparisonMeasureAccessor && comparisonMeasureAccessor(currentPoint);

    const formattedTargetValue = formatValueAsMetricNumber(targetValue);

    return Messages.metricsTargetRowSubtitle({ targetValue: formattedTargetValue });
  };
};

export const targetValueSubtitle = (value: number, formatString?: string): string => {
  const formattedTargetValue = formatValueAsMetricNumber(value, formatString);
  return Messages.metricsTargetRowSubtitle({ targetValue: formattedTargetValue });
};
